import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Markdown renderer for thread and reply bodies.
 * Supports basic GFM (lists, code, links, blockquotes, emphasis).
 */
export default function Markdown({ children, className = "" }) {
  return (
    <div className={`prose-gita ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" />,
          // Disable raw HTML to prevent injection
          script: () => null,
        }}
        skipHtml
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
